/**
 * 提供统一错误处理
 */
import axios from 'axios';
import { Message } from 'element-ui';
import qs from 'qs';
import get from 'lodash/get';

import { getParam, getToken } from './';
import { show, hide } from './loading';
import { safeSetStorage } from './index';

const MODULE_URL = {
  // 工作协同
  work: process.env.VUE_APP_API_HOST_WORK,
  // 测风数据
  windData: process.env.VUE_APP_API_HOST_WINDDATA,
  // 用户管理
  manage: process.env.VUE_APP_API_HOST_MANAGE,
  //
  flow: process.env.VUE_APP_API_HOST_FLOW
};

function prefixUrl(rawAxios) {
  return (url, param) => {
    let prefix = process.env.VUE_APP_API_HOST;
    if (MODULE_URL[param.module]) {
      prefix = MODULE_URL[param.module];
      param.module = null;
    }
    if (param.methods && param.methods === 'post') {
      delete param.module;
      param = param.data;
    }
    if (param.methods && param.methods === 'posts') {
      delete param.module;
      param = param.data.roleFunctionList;
    }
    if (url.indexOf('/') !== 0) {
      prefix += '/';
    }
    url = `${prefix}${url}`;
    return rawAxios(url, param);
  };
}

function prefixToken(data, apikey = getToken()) {
  try {
    const apiKey = apikey;
    if (!apiKey) return data;
    if (!data) return { apiKey };
    if (typeof data === 'object') {
      data.apiKey = apiKey;
    }
    return data;
  } catch (e) {
    return data;
  }
}

function replaceUrl(vue) {
  if (vue && vue.$router) {
    if (vue.$route.name !== 'project-list') {
      let path = '/';
      if (location.hash) {
        path = `${path}?callbackUrl=${encodeURIComponent(
          location.hash.slice(1)
        )}`;
      }

      vue.$router.replace(path);
      return;
    }
    return;
  }

  if (!(location.href.endsWith('#/') || location.href.includes('#/?'))) {
    let path = '#/';
    if (location.hash) {
      if (location.hash.indexOf('callbackUrl') === -1) {
        let str = location.hash.slice(1);
        path = `${path}?callbackUrl=${encodeURIComponent(str)}`;
      } else {
        let str2 = location.hash.slice(2);
        path = `${path}${str2}`;
      }
    }
    location.replace(path);
    return;
  }
}

/**
 * 增强 axios，支持错误处理，loading 及消息处理
 * @param showError 支持弹出错误消息
 * @param showSuccess 支持弹出成功消息
 * @param showLoading 支持loading
 */
function exhanceAxios(rawAxios) {
  return (url, param = {}) => {
    if (typeof url !== 'string') {
      const { url: realUrl, ...realParam } = url;
      url = realUrl;
      param = realParam;
    }
    let {
      showError = false,
      showSuccess = false,
      showLoading = false,
      noKey = false,
      noJudge = false,
      getRes = false,
      ...others
    } = param;
    if (showLoading) {
      show(showLoading);
    }

    if (others.method === 'post' || others.method === 'POST') {
      if (noKey) {
        others.data = prefixToken(others.data, '0');
      } else {
        others.data = prefixToken(others.data);
      }
    } else {
      if (noKey) {
        others.params = prefixToken(others.params, '0');
      } else {
        others.params = prefixToken(others.params);
      }
    }
    return rawAxios(url, others)
      .then(res => {
        if (noJudge) {
          if (showLoading) {
            hide();
          }
          return res;
        } else {
          if (!res || !res.data || res.data.code !== 0) {
            return Promise.reject(res);
          }
          if (showLoading) {
            hide();
          }
          if (showSuccess && res.data.message)
            Message.success({ message: res.data.message });
          //console.log(url, others, res);
        }
        return res.data;
      })
      .catch(res => {
        if (showLoading) {
          hide();
        }

        if (getRes) {
          return res.data;
        }
        const err = new Error(
          get(res, 'data.message') || res.message || '网络繁忙，请稍后再试'
        );

        const code = +get(res, 'data.code');
        if (code === 401 || code === 402) {
          safeSetStorage('apiKey', '');
          replaceUrl(this);
          return res;
        }
        if (code === 403) {
          err.res = res;
          if (showError && err.message !== '账号已在其他设备登录、请重新登录') {
            Message.error({ message: err.message });
          }
          safeSetStorage('apiKey', '');
          replaceUrl(this);
          return res;
        }
        err.res = res;
        if (showError && code !== 2) Message.error({ message: err.message });
        console.error(url, others, res);
        throw err;
      });
  };
}

let fetch = exhanceAxios(prefixUrl(axios));
fetch.get = exhanceAxios(prefixUrl(axios.get));
fetch.post = exhanceAxios(prefixUrl(axios.post));

const param = getParam();
if (process.env.VUE_APP_FETCH === 'MOCK' && param.mock === 'true') {
  const mockData = require('../../mockup').default;
  const mock = (url, options) => {
    if (typeof url !== 'string') {
      const { url: realUrl, ...realParam } = url;
      url = realUrl;
      options = realParam;
    }
    if (typeof mockData[url] === 'undefined') {
      return axios(url, options);
    }
    return new Promise(resolve => {
      setTimeout(() => {
        const res =
          typeof mockData[url] === 'function' ? mockData[url]() : mockData[url];
        //console.log(url, 'mock res', res);
        resolve({ data: res });
      }, 500);
    });
  };
  fetch = exhanceAxios(mock);
  fetch.get = fetch;
  fetch.post = fetch;
}

export default fetch;

export function postForm(url, param = {}) {
  if (typeof url !== 'string') {
    let { url: realUrl, ...realParam } = url;
    url = realUrl;
    param = realParam;
  }
  let { data, noKey, noJudge = false, ...others } = param;
  if (noKey) {
    data = prefixToken(data, '0');
  } else {
    data = prefixToken(data);
  }

  return fetch({
    url,
    noJudge,
    data: qs.stringify(data),
    ...others,
    method: 'POST',
    flag: 'form',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    }
  });
}
